window.colab = function () {
    "use strict";

    // Private
    const regexMainHeadingTagName = /^H2$/i;
    const regexAnyHeadingTagName = /^H[1-5]$/i;
    const regexTableTag = /\[Table\]/i;
    const regexGlossaryTag = /\[Glossary\]/i;
    const regexTutorialTag = /\[Tutorial\]/i;
    const regexImageColumnTag = /\[ImageColumn\]/i;
    const regexEndTag = /\[End\]/i;
    const regexAnyTag = /\[[^\]]+\]/;
    const regexTrimGlossary = /^[\s.]+/;

    const regexCUHKReplaceTag = /\[CUHK ([^\]]+)\]/i;

    const copyArray = function (arr) {
        let out = [];
        for (var i = 0; i < arr.length; i++) {
            out.push(arr[i]);
        }
        return out;
    }

    const forEachSkip = function (skip, arr, callfunc) {
        for (var i = skip; i < arr.length; i++) {
            callfunc(arr[i]);
        }
    }

    const elementReader = function (htmlCollection) {
        let i = 0;
        let arr = copyArray(htmlCollection);
        return {
            /** @returns {Element} */
            back: function () {
                i--;
            },
            next: function () {
                return arr[i++];
            },
            hasData: function () {
                return i < arr.length;
            }
        }
    }

    const parserSplitUL = function (child) {

        if (child.tagName == "UL") {
            let cols = [];
            child.querySelectorAll(":scope > li").forEach(li => {
                cols.push({ html: li.innerHTML.replace(regexAnyTag, ""), text: li.textContent, isList: true });
            });
            return cols;
        }
        return [{ html: child.innerHTML, text: child.textContent, isList: false }];
    }

    const extractTableLayout = function (childNodes) {
        let rows = [];

        let currentRow = [];
        rows.push(currentRow);
        let newRow = false;

        while (childNodes.hasData()) {
            let child = childNodes.next();
            processContentTags(child);

            if (child.tagName.match(regexMainHeadingTagName)) {
                childNodes.back();
                break;
            }

            child.remove();

            if (child.textContent.match(regexEndTag)) {
                break;
            }

            if (newRow) {
                currentRow = [];
                rows.push(currentRow);
                newRow = false;
            }

            var cols = parserSplitUL(child);
            if (!cols[0].isList) {
                // Single column
                currentRow.push(cols[0]);
            } else {
                // Multiple columns
                cols.forEach(col => {
                    currentRow.push(col);
                });
                // Begin new row after bullet list
                newRow = true;
            }
        }

        return { rows: rows };
    }

    const extractImageColumns = function (childNodes) {
        let leftColumn = [];
        let rightColumn = [];

        while (childNodes.hasData()) {
            let child = childNodes.next();
            processContentTags(child);

            if (child.tagName.match(regexAnyHeadingTagName)) {
                childNodes.back();
                break;
            }

            child.remove();

            if (child.textContent.match(regexEndTag)) {
                break;
            }

            if (child.classList.contains('kg-image-card')) {
                rightColumn.push(child.outerHTML);
            } else {
                leftColumn.push(child.outerHTML);
            }
        }
        return { left: leftColumn, right: rightColumn };
    }

    const processContentTags = function(htmlNode){
        var innerHtml = htmlNode.innerHTML;
        if (innerHtml.match(regexCUHKReplaceTag)){
            htmlNode.innerHTML = innerHtml.replace(regexCUHKReplaceTag, (match, group1) => {
                group1 = group1.toLowerCase();
                switch(group1){
                    case "makerspace location":
                        return "MakerSpace, Lower Ground Floor, Learning Garden, Chinese University of Hong Kong Library.<br/><a href='https://libguides.lib.cuhk.edu.hk/makerspace/highperformancew'>https://libguides.lib.cuhk.edu.hk/makerspace/highperformancew</a>"
                }
                return match;
            });
        }
    }

    const sortGlossaryTable = function(rows){
        rows.sort((a, b) => {
            let atxt = a[0].text.replace(regexTrimGlossary, "");
            let btxt = b[0].text.replace(regexTrimGlossary, "");
            return atxt.localeCompare(btxt);
        })
    }

    const renderGlossaryTable = function(html, rows){
        rows.forEach(row => {
            html.push(`<tr><th>${row[0].html}</th><td>`)
            forEachSkip(1, row, col => {
                html.push(`<p>${col.html}</p>`)
            });
            html.push("</td></tr>")
        });
    }

    // Public
    const initMainContent = function () {
        const mainContent = document.getElementById("maincontent");

        // Let url links have linebreaks in them
        mainContent.querySelectorAll('a').forEach(link => {
            if(link.innerHTML.indexOf("<") < 0){
                // Only update links that don't contain any tags
                link.innerHTML = link.innerHTML.replaceAll("/", "/<wbr/>");
            }
        });

        // Build custom layout tags
        let childNodes = elementReader(mainContent.children);
        let html = [];
        while (childNodes.hasData()) {
            let child = childNodes.next();
            processContentTags(child);
            let textContent = child.textContent;

            // Build content table
            if (textContent.match(regexTableTag)) {
                let repalceElement = child;

                let table = extractTableLayout(childNodes);

                html = [];
                html.push("<div class='tablecontainer'><table class='contenttable'><thead><tr>");

                let headerCols = table.rows[0].length;
                table.rows[0].forEach(col => {
                    html.push(`<th>${col.html}</th>`)
                });
                html.push("</tr></thead><tbody>");
                forEachSkip(1, table.rows, row => {
                    html.push("<tr>");
                    html.push(`<th class='header' colspan='${headerCols}'>${row[0].html}</th>`);
                    html.push("</tr><tr>");
                    forEachSkip(1, row, col => {
                        html.push(`<td>${col.html}</td>`)
                    });
                    html.push("</tr>");
                });

                html.push("</tbody></table></div>");
                repalceElement.outerHTML = html.join("");
                continue;
            }

            // Build glossary / tutorial table
            if (textContent.match(regexGlossaryTag) || textContent.match(regexTutorialTag)) {
                let isGlossary = textContent.match(regexGlossaryTag);
                let repalceElement = child;
                let table = extractTableLayout(childNodes);
                
                if (isGlossary) {
                    sortGlossaryTable(table.rows);
                }
                html = [];
                html.push(isGlossary ? "<table class='glossarytable'><tbody>" : "<table class='tutorialtable'><tbody>");
                renderGlossaryTable(html, table.rows);
                html.push("</tbody></table>");
                repalceElement.outerHTML = html.join("");
                continue;
            }

            // Image column
            if (textContent.match(regexImageColumnTag)) {
                let repalceElement = child;
                let columnsHtml = extractImageColumns(childNodes);
                repalceElement.outerHTML = "<section class='imagecolumn'><div>"+columnsHtml.left.join("")+"</div><aside>"+columnsHtml.right.join("")+"</aside></secion>";
                continue;
            }
        }
    }

    const initMainIndex = function () {
        const mainContent = document.getElementById("maincontent");
        const mainIndex = document.getElementById("mainindex");

        let childNodes = elementReader(mainContent.children);
        let navElements = [];
        let lastH2 = null;
        while (childNodes.hasData()) {
            let child = childNodes.next();
            if (child.tagName == "H2") {
                lastH2 = { name: child.innerHTML, id: child.id, children: [] };
                navElements.push(lastH2);
            }
            if (child.tagName == "H3" && lastH2) {
                lastH2.children.push({ name: child.innerHTML, id: child.id });
            }
        }
        let html = [];
        html.push("<nav><ul>")
        navElements.forEach(x => {
            html.push(`<li><a href="#${x.id}">${x.name}</a>`);
            if (x.children.length > 0) {
                html.push("<ul>")
                x.children.forEach(y => {
                    html.push(`<li><a href="#${y.id}">${y.name}</a></li>`);
                });
                html.push("</ul>")
            }
            html.push("</li>")
        });
        html.push("</ul></nav>");

        mainIndex.innerHTML = html.join("");
    }

    const initGlossaryPage = function(){
        const glossasryContent = document.getElementById("glossarycontent");
        let childNodes = elementReader(glossasryContent.children);
        let glossasryRows = [];
        while (childNodes.hasData()) {
            let child = childNodes.next();
            processContentTags(child);
            let textContent = child.textContent;

            if (textContent.match(regexGlossaryTag)) {
                let repalceElement = child;
                let table = extractTableLayout(childNodes);
                table.rows.forEach(x => {glossasryRows.push(x)});
            }
        }

        sortGlossaryTable(glossasryRows);
        html = [];
        html.push("<section class='glossary'><table class='glossarytable'><tbody>");
        renderGlossaryTable(html, glossasryRows);
        html.push("</tbody></table></section>");
        glossasryContent.outerHTML = html.join("");
    }

    return {
        initMainContent: initMainContent,
        initMainIndex: initMainIndex,
        initGlossaryPage: initGlossaryPage,
    }
}();
















